import React from 'react'
import zousan from 'zousan'

import { StateObj } from '../../../../src/utils/stateObj.js'

import { AttributionDataType, AttributionModalView } from './AttributionModalView.js'

const VIEW_ID = 'attributionModal'

function create (app, config) {
  const widgetState = new StateObj({ properties: [] })

  const init = () => {}
  const identity = x => x

  const prepareModalData = () => zousan.all([
    app.bus.get('venueData/getAssetsTimestamp'),
    app.bus.get('venueData/getVenueId'),
    app.bus.get('venueData/getPositioningSupported'),
    app.bus.send('analytics2/getInstallId'),
    app.bus.get('map/getMapCenter'),
    app.bus.get('map/getCurrentView'),
    app.bus.getFirst('user/getPhysicalLocation')
  ])
    .then(([mapAssetsTimestamp, venueId, positioningSupported, installIdResponse, mapCenter, currentViewport, userLocation]) => {
      const coreLocationEnabled = positioningSupported && positioningSupported.includes('CoreLocation')
      return [
        {
          label: 'Map Assets Timestamp',
          value: mapAssetsTimestamp,
          type: AttributionDataType.SIMPLE
        },
        {
          label: 'Venue',
          value: venueId && venueId.toUpperCase(),
          type: AttributionDataType.SIMPLE
        },
        {
          label: 'Core Location Enabled',
          value: coreLocationEnabled ? 'Yes' : 'No',
          type: AttributionDataType.SIMPLE
        },
        installIdResponse && installIdResponse.length
          ? {
            label: 'Install ID',
            value: installIdResponse[0],
            type: AttributionDataType.SIMPLE
          }
          : null,
        {
          label: 'Map Center',
          value: prepareMapCenterLabel(mapCenter),
          type: AttributionDataType.COMPLEX
        },
        userLocation && {
          label: 'Current Location',
          value: prepareCurrentLocationLabel(userLocation, currentViewport),
          type: AttributionDataType.COMPLEX
        }
      ].map(identity)
    })

  const prepareMapCenterLabel = ({ lat, lng, floorId, structureId }) => [
    { label: 'Position', value: `[ ${lat}, ${lng} ]` },
    { label: 'Floor', value: floorId },
    { label: 'Structure', value: structureId }
  ]

  const prepareCurrentLocationLabel = (location, { zoom, bearing, pitch }) => {
    const { lat, lng } = location
    return [
      { label: 'Position', value: `[ ${lat}, ${lng} ]` },
      { label: 'Floor', value: location.floorId },
      { label: 'Zoom', value: zoom },
      { label: 'Bearing', value: bearing },
      { label: 'Pitch', value: pitch }
    ]
  }

  app.bus.send('layers/register', {
    id: VIEW_ID,
    widget: () => <AttributionModalView
      engineName={ app.config.engineName || app.config.name }
      onModalDismiss={() => app.bus.send('layers/hide', { id: VIEW_ID })}
      properties={widgetState.getState().properties}
      T={app.gt()}
      versionNumber={app.info.wePkg.version}
      privacyPolicyUrl={'https://www.acuitybrands.com/privacy-policy'}
      tosUrl="https://www.acuitybrands.com/support/warranty/terms-and-conditions"
    />,
    show: false,
    isOverlay: true,
    layoutId: 'modalWindow',
    layoutName: 'fullscreen'
  })

  app.bus.on('appInfo/watermarkClicked', async () => {
    const modalData = await prepareModalData()
    widgetState.update({ properties: modalData })
    app.bus.send('layers/show', { id: VIEW_ID })
  })

  return {
    init
  }
}

export {
  create
}
